<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

        <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" /> -->

        <div v-if="activeUserInfo.role && (activeUserInfo.role == 'secretary' || activeUserInfo.role == 'enfermera')">
          <vs-select
            class="selectExample ml-2"
            v-model="activeDoctorID" 
            placeholder="Seleccione un Doctor"
          >
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in doctors_list" />
          </vs-select>
        </div>
        <vs-spacer />

        <!-- <i18n /> -->


        <!-- <cart-drop-down /> -->

        <notification-drop-down />

        <profile-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>


<script>
import Bookmarks            from './components/Bookmarks.vue'
// import I18n                 from './components/I18n.vue'
import SearchBar            from './components/SearchBar.vue'
// import CartDropDown         from './components/CartDropDown.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import Multiselect          from 'vue-multiselect'

export default {
  name: 'the-navbar-vertical',
  data () {
    return {
      activeDoctorID: null,
      isSecretary: false,
      activeDoctorData: {},
      options2:[
        {text: 'Doctor 1', value: 1},
        {text: 'Doctor 2', value: 2},
        {text: 'Doctor 3', value: 3}
      ],
    }
  },
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    Bookmarks,
    // I18n,
    SearchBar,
    // CartDropDown,
    NotificationDropDown,
    ProfileDropDown,
    Multiselect
  },
  computed: {
    doctors_list() {
      console.log(this.$store.state.AppActiveUser);
      return this.$store.state.AppActiveUser.meta.doctorsList ?
        this.$store.state.AppActiveUser.meta.doctorsList.map(
          doctor => 
          ({ text: `${doctor.doctorData.first_name} ${doctor.doctorData.last_name}`, value : doctor.doctorId })
          )
          : [] 
    },
    // notificationsList(){
    //   return this.$store.state.notifsList;
    // },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    }
  },
  beforeMount (){
    if(this.activeUserInfo.role == 'secretary' || this.activeUserInfo.role == 'enfermera'){          
        this.activeDoctorID =  sessionStorage.getItem('activeDoctorId') !== null ? sessionStorage.getItem('activeDoctorId') : this.doctors_list[0].value; 
        sessionStorage.setItem('activeDoctorId', this.activeDoctorID);
   }
    
    console.log('active doctor: ',this.activeDoctorID);
    

    // if(this.activeUserInfo.role !== "doctor" ){
    //     this.isSecretary = true;
    //     this.$store.dispatch('getDoctorDataById', sessionStorage.getItem('activeDoctorId')).then(response=>{
    //       console.log('DOCTOR: ',response);
    //       this.activeDoctorData = JSON.parse(JSON.stringify(response.data.data.user));
    //     }, error => {
    //       console.error(error);
    //     });
    //   } else {
    //     this.isSecretary = false;
    //   }
  },
  mounted () {
    if(this.doctors_list){
      console.log('doct_list', this.doctors_list);
    }
    
    this.$store.dispatch('fetchEvents');
    // if(this.isSecretary){
    //   this.$store.dispatch('fetchNotifs', this.activeDoctorData.email);
    // } else {
    //   this.$store.dispatch('fetchNotifs', this.activeUserInfo.email);
    // }
    // setTimeout(() => {
    //   console.log('NOTIFS_LIST: ',this.notificationsList);
    // }, 1000);
    
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  },
  watch: {
    activeDoctorID (newVal, oldVal) {
      console.log('OLD: ',oldVal ,' NEW: ' , newVal);

      if((oldVal !== newVal) && oldVal !== null){
        sessionStorage.setItem('activeDoctorId', newVal);
        setTimeout(() => {
          location.reload();
        }, 200);
      }

      // // ------------

      // this.$store.dispatch('updateDoctorID', id).then((response) =>{
        
      //   location.reload();
      // });
      // console.log('active doctor:', this.$store.state.activeDoctorID);

    }
  }
}
</script>

